import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  Validators,
  FormGroup,
} from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/services/alert.service';
import { BookingService } from 'src/app/services/booking.service';
import { Router } from '@angular/router';
import { EventType } from 'src/enum/eventtype';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RoleType } from 'src/enum/roletype';

@Component({
  selector: 'app-aeesendbackpopup',
  templateUrl: './aeesendbackpopup.component.html',
  styleUrls: ['./aeesendbackpopup.component.scss']
})
export class AeesendbackpopupComponent implements OnInit {
  showNotes: boolean = true;  
  sentbackform:FormGroup;
  id: any;
  public eventEnum = EventType;
  public roleEnum=RoleType
  isDisabled: boolean;
  loading: boolean;
  roleid: number;

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private router: Router,
    public dialogRef: MatDialogRef<AeesendbackpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    private bookingService: BookingService,
    public addServiceDialog: MatDialog,
    public usersessionService:UserSessionService
  ) {
    this.id = this.dataRecievedData;
    this.roleid=this.usersessionService.roleId()
  }


  ngOnInit(): void {
    this.showNotes = true;
    this.initializeValidators();
  }


  initializeValidators() {   
    this.sentbackform = this.formBuilder.group({
      sendbackremarks: [null, Validators.required]
    })
  }

  sendbackcancel(isProceed) {
    this.dialogRef.close(isProceed);

  }

  validateFormControl() {
    Object.keys(this.sentbackform.controls).forEach((field) => {
      const control = this.sentbackform.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  // sendbackremarks() {
  //   if (this.sentbackform.valid) {
  //     let request = {
  //       id: this.id,
  //       eventType: 7,
  //       approvedStatusType: 1,
  //       remarks: this.sentbackform.value.remarks,
  //     };
  //     this.bookingService
  //       .approvalmanufacturerapproval(request)
  //       .subscribe((res) => {
  //         if (res && res.isSuccess) {
  //           this.alertService.success('Successfully Approved the farmer Subsidy');
  //           this.dialogRef.close();
  //           this.router.navigate(['/eefarmerbookingapproval'])
  //         }
  //         else {
  //           this.alertService.error(res.htmlFormattedFailures);
  //         }
  //       });
  //   } else {
  //     this.validateFormControl()
  //   }
  // }
  sendbackremarks(){
    this.isDisabled = true;
    this.loading = true;
    if (this.sentbackform.valid) {
      let request = {
        id: this.id,
        eventType:this.eventEnum.AESendBack ,
        remarks: this.sentbackform.value.sendbackremarks,
      };
      this.bookingService
        .sendBack(request)
        .subscribe((res) => {
          if (res) {
            this.isDisabled = false;
            this.loading = false;
            this.alertService.success(this.roleid==this.roleEnum.AssistantEngineer?'AE Send Back Successfully':this.roleid==this.roleEnum.HortiADH?'ADH Send Back Successfully':this.roleid==this.roleEnum.AgricultureAO?'AO Send Back Successfully':'');
            this.dialogRef.close();
            this.router.navigate(['/aefarmerbooking'])
          }
          else {
            this.isDisabled = false;
            this.loading = false;
            // this.alertService.error(res.htmlFormattedFailures);
          }
        });
    } else {
      this.isDisabled = false;
      this.loading = false;
      this.validateFormControl()
    }
  }
}
